<div class="p-field" *ngIf="formControl">
  <label for="wardGeoId">{{ 'Xã/phường'|translate }}</label>
  <p-dropdown id="wardGeoId" appendTo="body"  [options]="counties" [filter]="true" [formControl]="formControl"
              [showClear]="true" placeholder="-" (ngModelChange)="ngModelChange()"></p-dropdown>
</div>
